import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Select,
  MenuItem,
  SelectChangeEvent,
  Fab
} from '@mui/material';
import React from 'react';
import { useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

const UserList: React.FC = () => {
  // This would typically come from an API/props
  const [users, setUsers] = useState<User[]>([
    {
      id: '1',
      name: 'Gerry Fernando Patia',
      email: 'gerry@dokai.ai',
      role: 'admin'
    },
    { id: '2', name: 'Rio Atmadja', email: 'rio@dokai.ai', role: 'admin' },
    {
      id: '3',
      name: 'Rafferty Askara',
      email: 'rafferty@dokai.ai',
      role: 'user'
    },
    {
      id: '4',
      name: 'Sarah Johnson',
      email: 'sarah.j@dokai.ai',
      role: 'user'
    },
    {
      id: '5',
      name: 'Michael Chen',
      email: 'michael.c@dokai.ai',
      role: 'user'
    },
    {
      id: '6',
      name: 'Emily Rodriguez',
      email: 'emily.r@dokai.ai',
      role: 'user'
    },
    {
      id: '7',
      name: 'James Wilson',
      email: 'james.w@dokai.ai',
      role: 'user'
    },
    { id: '8', name: 'Sofia Patel', email: 'sofia.p@dokai.ai', role: 'user' },
    {
      id: '9',
      name: 'Lucas Kim',
      email: 'lucas.k@dokai.ai',
      role: 'user'
    },
    {
      id: '10',
      name: 'Emma Thompson',
      email: 'emma.t@dokai.ai',
      role: 'user'
    },
    { id: '11', name: 'Daniel Lee', email: 'daniel.l@dokai.ai', role: 'user' },
    {
      id: '12',
      name: 'Olivia Garcia',
      email: 'olivia.g@dokai.ai',
      role: 'user'
    }
  ]);
  const [hasChanges, setHasChanges] = useState(false);

  const handleRoleChange = (userId: string) => (event: SelectChangeEvent) => {
    setUsers(
      users.map((user) =>
        user.id === userId ? { ...user, role: event.target.value } : user
      )
    );
    setHasChanges(true);
  };

  const handleSave = () => {
    // Here you would typically make an API call to save the changes
    setHasChanges(false);
  };

  return (
    <>
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {users.map((user) => (
          <ListItem
            key={user.id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: '1px solid #e0e0e0',
              py: 2
            }}
          >
            <ListItemText
              primary={user.name}
              secondary={user.email}
              sx={{ mr: 2 }}
            />
            <Select
              value={user.role}
              onChange={handleRoleChange(user.id)}
              size="small"
              sx={{ minWidth: 120 }}
            >
              <MenuItem value="user">User</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="manager">Manager</MenuItem>
            </Select>
          </ListItem>
        ))}
      </List>
      {hasChanges && (
        <Fab
          variant="extended"
          color="primary"
          sx={(theme) => ({
            backgroundColor: theme.customColors.themePrimary,
            position: 'fixed',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            paddingLeft: 2,
            paddingRight: 2
          })}
          onClick={handleSave}
        >
          <SaveIcon sx={{ mr: 1 }} />
          Save
        </Fab>
      )}
    </>
  );
};

const UserAccessPage: React.FC = () => {
  return (
    <Box
      sx={{
        flex: 1,
        padding: '16px',
        width: '600px',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        alignSelf: 'center',
        flexWrap: 'wrap'
      }}
    >
      <Box
        sx={{
          width: '100%',
          marginBottom: '50px'
        }}
      >
        <Typography
          sx={{
            maxWidth: '100%',
            wordWrap: 'break-word',
            fontWeight: '600',
            fontSize: '26px',
            marginBottom: '20px'
          }}
        >
          User Access Management
        </Typography>
        <Box
          sx={{
            marginBottom: '20px'
          }}
        >
          <Box>
            <Typography>Roles</Typography>
          </Box>
          <UserList />
        </Box>
      </Box>
    </Box>
  );
};

export default UserAccessPage;
